var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".person_svg__user-icon{fill:#f0f6f9;stroke:#0194d3}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1560.145 -109)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "person_svg__user-icon",
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  transform: "translate(1560.645 109.5)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "person_svg__user-icon",
  cx: 4.45,
  cy: 4.45,
  r: 4.45,
  transform: "translate(1566.695 113.5)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "person_svg__user-icon",
  d: "M3.575 18.575a10.5 10.5 0 0 1 14.773-.075"
})));
export default SvgPerson;